import { configureStore } from "@reduxjs/toolkit";
import appStateSlice from "./features/appStateSlice";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { planoAPI } from "./features/cache";

export const store = configureStore({
  reducer: {
    [planoAPI.reducerPath]: planoAPI.reducer,
    appState: appStateSlice
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }).concat(planoAPI.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;